import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
import debounce from "debounce";


export default class extends Controller {

    static targets = ["messageBox","deliverable","catchAll","notFound","taskUuid","format"]


  connect() { }

      singleSearchForm(event){
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
              this.element.requestSubmit()
          }, 250)
      }

    checkAndPreviewData(event){
        document.getElementById("check_field_" + event.target.id + "_warning").classList.add("hidden");
        document.getElementById("check_field_" + event.target.id + "_ok").classList.add("hidden");
        //document.getElementById("check_field_" + event.target.id + "_error").classList.add("hidden");
        document.getElementById( event.target.id + "_loading").classList.remove("hidden");

        let previewElement = document.getElementById('preview_data');
        let preview;

        if (previewElement == undefined){
            if(event.target.id.startsWith('contact')) {
                preview = [].slice.call(document.getElementById('preview_data_contacts').options).map(x => x.value);
            } else if(event.target.id.startsWith('company')) {
                preview = [].slice.call(document.getElementById('preview_data_companies').options).map(x => x.value);
            }
        } else {
            preview = [].slice.call(previewElement.options).map(x => x.value);
        }
        let selectedValue = event.target.value;

        // if not consists of numbers -> field from hubspot -> select choiceLabel
        if(!/^\d+$/.test(selectedValue)) {
            selectedValue = event.target.selectedOptions[0].dataset.choiceIndex
        }

        let previewData = ""
        if(preview[selectedValue] != undefined){
            previewData = preview[selectedValue]
        }

        //Check Data
        if (selectedValue == "") {
            document.getElementById( event.target.id + "_loading").classList.add("hidden");
            document.getElementById("check_field_" + event.target.id + "_warning").classList.add("hidden");
            document.getElementById("check_field_" + event.target.id + "_ok").classList.add("hidden");
            if(event.target.id == "contact_first_name" || event.target.id == "contact_last_name" || event.target.id == "company_name" || event.target.id == "company_domain"){
                //document.getElementById("check_field_" + event.target.id + "_error").classList.remove("hidden");
               // document.getElementById("btnStep1Next").classList.add("hidden");
            }
        } else {

            let data = new FormData()
            data.append("preview_data", previewData)
            data.append("mapped_field", event.target.id)
            Rails.ajax({
                url: "/tasks/check_preview_data",
                type: 'POST',
                data: data,
                success: function (data) {
                    if (data.success) {
                        document.getElementById( event.target.id + "_loading").classList.add("hidden");
                        document.getElementById("check_field_" + event.target.id + "_warning").classList.add("hidden");
                        document.getElementById("check_field_" + event.target.id + "_ok").classList.remove("hidden");
                        //document.getElementById("check_field_" + event.target.id + "_error").classList.add("hidden");
                        //document.getElementById("submit_btn").classList.remove("hidden");
                    } else {
                        document.getElementById( event.target.id + "_loading").classList.add("hidden");
                        document.getElementById("check_field_" + event.target.id + "_warning").classList.remove("hidden");
                        document.getElementById("check_field_" + event.target.id + "_ok").classList.add("hidden");
                       // document.getElementById("check_field_" + event.target.id + "_error").classList.add("hidden");
                        //document.getElementById("submit_btn").classList.remove("hidden");
                    }
                }
            });
        }
        //preview
        document.getElementById(event.target.id + "_preview").innerHTML = previewData
    }



     archiveTask() {

      const taskID = this.element.id;
      const taskItem = "item_task_" + taskID;

     Rails.ajax({
         url: "/tasks/"+taskID+"/archive",
         type:'PUT',
         success: function(data) {
             if (data.success){
                 document.getElementById(taskItem).classList.add('hidden')
             }
         }
     })

  }

  exportFile(){
      //let messageBox = this.messageBoxTarget
      let data = new FormData()
      data.append("deliverable", this.deliverableTarget.checked)
      data.append("catch_all", this.catchAllTarget.checked)
      data.append("not_found", this.notFoundTarget.checked)
      data.append("format", this.formatTarget.value)

      Rails.ajax({
          url: "/tasks/" + this.taskUuidTarget.id + "/export",
          type:'POST',
          data: data,
          success: function(data) {
                  //messageBox.classList.remove('invisible')
                  //let title = data.success ? "Success" : "Error"
                  //document.getElementById("messageBoxSuccessStatus")._x_model.set(data.success.toString())
                  //document.getElementById("msg-title").innerHTML = title
                  //document.getElementById("msg-content").innerHTML = data.message
                  //setTimeout(() => { messageBox.classList.add('invisible'); }, 5000);

          }
      })
  }

    verifyScrubby(){
        let messageBox = this.messageBoxTarget

        Rails.ajax({
            url: "/tasks/" + this.taskUuidTarget.id + "/scrubby",
            type:'POST',
            success: function(data) {
                messageBox.classList.remove('invisible')
                let title = data.success ? "Success" : "Error"
                document.getElementById("messageBoxSuccessStatus")._x_model.set(data.success.toString())
                document.getElementById("msg-title").innerHTML = title
                document.getElementById("msg-content").innerHTML = data.message
                setTimeout(() => { messageBox.classList.add('invisible'); }, 5000);

            }
        })
    }


}
